const PLUGIN_NAME = 'ecommerce-kp-components';
const BLAZE_AUTH_TOKEN_CODE = 'wsb_api_authorization';
const BLAZE_AUTH_EMAIL_CODE = 'wsb_api_email';
const BLAZE_CART_ID_KEY = 'blaze_cart_id';

export { PLUGIN_NAME, BLAZE_AUTH_TOKEN_CODE, BLAZE_AUTH_EMAIL_CODE, BLAZE_CART_ID_KEY };
